/**
 * Product ESM entry point. Loaded on template.name == 'product'.
 *
 * AI: Entirely written by AI
 * Date: 2026-05-04
 * Model: Claude Opus 4.7
 *
 * [EntryProduct]
 */

import { log } from './log.js';
import './sizing-modal-opener.js';
import './product.js';

log('[App] entry-product loaded');
